import { Button, Link } from "@mui/material";
import { Box, styled } from "@mui/system";

export const LandingContainer = styled(Box)({
  maxWidth: "1200px",
  margin: "auto",
  padding: "10px 0",
  display: "flex",
});
export const LandingBlock = styled(Box)({
  display: "flex",
  flexDirection: "column",
  marginRight: "50px",
});
export const ImgContainer = styled(Box)({
  marginBottom: "20px",
  "& img": {
    height: "200px",
  },
});
export const ListContainer = styled(Box)({
  marginTop: "24px",
});
export const ListItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "10px",
});
export const StyledLink = styled(Link)(({ theme }) => ({
  font: theme.typography.link.font,
  color: theme.palette.link.main,
  textDecoration: "none",
  alignItems: "center",
  display: "flex",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  font: theme.typography.button.font,
  textTransform: "none",
  marginTop: "41px",
  marginBottom:'20px'
}));
